import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { setTokenData } from "./OtpVerify";

export const BANK_ACCOUNT_NUMBER_NOT_CORRECT =
  "BANK_ACCOUNT_NUMBER_NOT_CORRECT";
export const MAX_SERVER_REQUESTS_ERROR = "MAX_SERVER_REQUESTS_ERROR";
export const MEMBER_NOT_FOUND = "MEMBER_NOT_FOUND";

export async function OtpVerifyRegisterWithBankAccount(
  userId: string,
  bankAccountNum: string,
  registerBankAccountTokenNum:string|null|undefined
) {
  if (userId?.length && bankAccountNum?.length) {
    try {
      const body = {
        registerBankAccountTokenMum: registerBankAccountTokenNum,
        bankAccountNum,
        bankCode: "1", // those values cant be null and not includes in server validation
        bankBranchCode: "1",
      };
      const path =
        environment.BASE_URL +
        "MemberRegister/OTPVerifyRegisterWithBankAccount";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (axiosUtil.isSuccess(res) && res?.data?.tokenNum?.length) {
        setTokenData(
          res.data.refreshTokenNum,
          res.data.tokenExpiryDate,
          res.data.refreshTokenExpiryDate
        );
        const token = res.data.tokenNum;
        return token;
      }
      if (res?.data?.errorCode === 50) return BANK_ACCOUNT_NUMBER_NOT_CORRECT;
      if (res?.data?.errorCode === 36) return MAX_SERVER_REQUESTS_ERROR;

      return "";
    } catch (err) {
      console.log(err);
    }
  }
  return "";
}

export const verifyWithBankAccountUtil = {
  isSuccess: (verifyBankAccountRes: any) =>
    verifyBankAccountRes !== BANK_ACCOUNT_NUMBER_NOT_CORRECT &&
    verifyBankAccountRes !== MAX_SERVER_REQUESTS_ERROR &&
    verifyBankAccountRes.length,

  isBankAccountNumberNotCorrect: (verifyBankAccountRes: any) =>
    verifyBankAccountRes === BANK_ACCOUNT_NUMBER_NOT_CORRECT,

  isMaxServerRequestsError: (verifyBankAccountRes: any) =>
    verifyBankAccountRes === MAX_SERVER_REQUESTS_ERROR,
};
